import { type SupApiEnv, default as apiConfig } from "@/../config/api";

export function getApiOriginValue(cookieValue: SupApiEnv | undefined = undefined): SupApiEnv {
  return apiConfig.switchAllowed && cookieValue && apiConfig.allowedOrigins.includes(cookieValue) ? cookieValue : apiConfig.defaultOrigin;
}
